/**
 * WHAT THE MODE IS CALLED (Tom, 2026-10-28, r-2026-10-28 Build/Script ruling).
 *
 * The tap-the-LEGO-tiles-into-order card is BUILD mode: Welsh, Irish and Italian
 * today, French and Spanish when they are switched on, any Roman-script language
 * later. "Script" is kept only where learning a new writing system is the point.
 * So the name is chosen by data, one list: a language whose script is not Roman
 * is named Script; every other language is Build. Korean, Japanese, Greek,
 * Armenian and the rest of the non-Roman scripts join the list as they arrive.
 *
 * Internal ids, route params and DB values stay "script"; this is the learner's
 * word only. Pure: no Vue, no imports, safe for the entry chunk.
 */

/** Three-letter target languages that teach a non-Roman writing system: named Script. */
export const SCRIPT_NAMED_LANGS: readonly string[] = [
  'ara', 'zho', 'jpn', 'kor', 'ell', 'hye', 'heb', 'rus', 'ukr', 'bul', 'fas', 'urd',
  'hin', 'ben', 'tam', 'tel', 'kan', 'mar', 'guj', 'pan', 'sin', 'tha', 'kat',
]

export type ModeNameKind = 'build' | 'script'

const lang3 = (lang: string | null | undefined): string => (lang ?? '').toLowerCase().slice(0, 3)

/** Build or Script, from a target language ("ita") or a course code ("ita_for_eng"). */
export const modeNameKind = (langOrCourse: string | null | undefined): ModeNameKind =>
  SCRIPT_NAMED_LANGS.includes(lang3(langOrCourse)) ? 'script' : 'build'

/** The i18n key under `family.` for this language: `buildX` for Build, `scriptX` for Script. */
export const isBuildMode = (langOrCourse: string | null | undefined): boolean => modeNameKind(langOrCourse) === 'build'
